// Sentry must be initialized before the rest of the app loads.
// Imported first thing from src/index.js.
import * as Sentry from '@sentry/react';
import { Capacitor } from '@capacitor/core';

const PRODUCTION_HOSTS = [
  'picknpray.com',
  'www.picknpray.com',
  'pick-n-pray.vercel.app',
];

// CRA only exposes REACT_APP_* vars, so derive the environment at runtime:
// production builds served from the real domain or inside the native app are
// "production", other production builds (Vercel previews) are "preview".
// REACT_APP_SENTRY_ENVIRONMENT overrides everything if set.
function resolveEnvironment() {
  if (process.env.REACT_APP_SENTRY_ENVIRONMENT) {
    return process.env.REACT_APP_SENTRY_ENVIRONMENT;
  }
  if (process.env.NODE_ENV !== 'production') return 'development';
  if (Capacitor.isNativePlatform()) return 'production';
  if (PRODUCTION_HOSTS.includes(window.location.hostname)) return 'production';
  return 'preview';
}

const dsn = process.env.REACT_APP_SENTRY_DSN;

// No DSN (local dev, CI) -> Sentry stays a no-op.
if (dsn) {
  const environment = resolveEnvironment();

  Sentry.init({
    dsn,
    environment,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: environment === 'production' ? 0.1 : 1.0,
    sendDefaultPii: false,
  });

  Sentry.setTag('platform', Capacitor.getPlatform());
}
